<template>
	<div class="default-wrapper">
		<b-breadcrumb class='bread-crumb'>
				<b-breadcrumb-item href="/#/fanzone/3/?callFrom=artist">Artyści</b-breadcrumb-item>
				<b-breadcrumb-item active>Artysta - <i>{{form.name}}</i></b-breadcrumb-item>
			</b-breadcrumb>
		<d-container fluid>
			<b-modal
				v-model='$store.state.artists.form.formSaveSuccess'
				title='Sukces'
				ok-only
				centered
			>
				<div class="d-block text-center">
					Dane artysty <i>{{form.name}}</i> zostały zapisane.
				</div>
			</b-modal>

			<b-modal
				v-model='$store.state.artists.form.formSaveError'
				title='Uwaga'
				ok-only
				centered
			>
				<div class="d-block text-center">
					Dane artysty <i>{{form.name}}</i> nie zostały zapisane.
				</div>
			</b-modal>

			<b-row class='mt-3'>
				<b-col cols='4'>

					<b-row>
						<b-col>
							<label>Status</label>
							<b-form-select
								v-model='form.status'
								:options='statusOptions'
								@input='(e) => actions.handleSetArtistData("status", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Nazwa</label>
							<b-form-input
								v-model='form.name'
								@input='(e) => actions.handleSetArtistData("name", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Bierze udział w głosowaniu</label>
							<b-form-checkbox
								class="ml-2 mr-sm-2 mb-sm-0"
								v-model='form.canVoted'
								@change='(e) => actions.handleSetArtistData("canVoted", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Opis PL</label>
							<b-form-textarea
								rows='3'
								max-rows='6'
								placeholder='wpisz opis...'
								v-model='form.description'
								@input='(e) => actions.handleSetArtistData("description", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Opis EN</label>
							<b-form-textarea
								rows='3'
								max-rows='6'
								placeholder='wpisz opis...'
								v-model='form.descriptionEN'
								@input='(e) => actions.handleSetArtistData("descriptionEN", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Opis skrócony PL</label>
							<b-form-input
								v-model='form.shortDescription'
								@input='(e) => actions.handleSetArtistData("shortDescription", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Opis skrócony EN</label>
							<b-form-input
								v-model='form.shortDescriptionEN'
								@input='(e) => actions.handleSetArtistData("shortDescriptionEN", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Apple Music url</label>
							<b-form-input
								v-model='form.appleMusicUrl'
								@input='(e) => actions.handleSetArtistData("appleMusicUrl", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Facebook url</label>
							<b-form-input
								v-model='form.facebookUrl'
								@input='(e) => actions.handleSetArtistData("facebookUrl", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Instagram url</label>
							<b-form-input
								v-model='form.instagramUrl'
								@input='(e) => actions.handleSetArtistData("instagramUrl", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>TikTok url</label>
							<b-form-input
								v-model='form.tiktokUrl'
								@input='(e) => actions.handleSetArtistData("tiktokUrl", e)'
							/>
						</b-col>
					</b-row>

					<b-row class='mt-3'>
						<b-col>
							<label>Spotify url</label>
							<b-form-input
								v-model='form.spotifyUrl'
								@input='(e) => actions.handleSetArtistData("spotifyUrl", e)'
							/>
						</b-col>
					</b-row>					
					
					<b-row class='mt-3'>
						<b-col>
							<label>Youtube url</label>
							<b-form-input
								v-model='form.youtubeUrl'
								@input='(e) => actions.handleSetArtistData("youtubeUrl", e)'
							/>
						</b-col>
					</b-row>
					<b-row class='mt-3'>
						<b-col>
							<label>Youtube id filmów</label>
							<b-form-input
								v-model='form.youtubeVideoIds'
								@input='(e) => actions.handleSetArtistData("youtubeVideoIds", e)'
							/>
						</b-col>
					</b-row>
					<b-row class='mt-3'>
						<b-col>
							<label>Spotify embed url</label>
							<b-form-input
								v-model='form.spotifyEmbedCode'
								@input='(e) => actions.handleSetArtistData("spotifyEmbedCode", e)'
							/>
						</b-col>
					</b-row>
				</b-col>

				<b-col cols='4'>
					<label>Zdjęcie</label>

					<b-form-file
						@change='imageUploaded'
						accept=".jpg, .png, .gif, .jpeg"
						placeholder='wybierz plik'
					/>

					<div v-if='true' class='mt-3 text-center previev-container'>
						<div class='image-size mb-1'>rozmiar obrazka: {{size}}</div>
						<img :src='imageUrl' class='preview' @load='onImageLoad' />
					</div>
				</b-col>
			</b-row>
			<b-row class='mt-3'>
				<b-col>
					<b-button
						variant='primary'
						@click='() => handleClickSave()'
					>
						Zapisz artystę
					</b-button>
				</b-col>	
			</b-row>	
		</d-container>		
	</div>
</template>

<script>
	import { sendRequest } from '@/api'
	import 'tui-editor/dist/tui-editor.css';
	import 'tui-editor/dist/tui-editor-contents.css';
	import 'codemirror/lib/codemirror.css';
	import Editor from '@toast-ui/vue-editor/src/Editor.vue'
	import vueFilePond from 'vue-filepond';
	import 'filepond/dist/filepond.min.css';
	import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
	import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
	import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
	import EventBus from '../eventBus';
	import { ARTIST_STATUS_OPTIONS } from '@/const'
	import { BModal } from 'bootstrap-vue'
	import {
		handleFillArtistForm,
		handleArtistImageUpload,
		handleSaveArtist,
		handleSetArtistData,
	} from '@/store/utils.js'
	import { baseURL } from '@/api'
	
	export default {
		props: ['id'],
		components: {
			Editor,
			'b-modal': BModal,
		},
		data() {
			return {
				actions: {
	        handleFillArtistForm,
					handleArtistImageUpload,
					handleSaveArtist,
					handleSetArtistData,
  	    },
				statusOptions: ARTIST_STATUS_OPTIONS,
				size: '',
				base64: null,
				baseURL: baseURL,
			}
		},
		computed: {
			imageUrl() {
        if (this.base64)
          return this.base64
        if (this.form.mainImage) {
          //this.baseURL + 
          return this.form.mainImage
        }
        return null
      },
			form() {
				return this.$store.state.artists.form
			},
			artist() {
				return this.$store.state.artists.all.find((a) => parseInt(a.id) === parseInt(this.id))
			},
		},
		mounted() {
			console.log("!!!!!!!", this.form)
			this.actions.handleFillArtistForm(this.id)
		},
		methods: {
			imageUploaded(e) {
        this.actions.handleArtistImageUpload('mainImage', e.target.files[0])

        const file = e.target.files[0]

        const reader = new FileReader()

        if (file) reader.readAsDataURL(file)

        const uploadData = this.handleUploadData.bind(this)
        reader.addEventListener('load', () => uploadData(reader.result), false)
      },
			handleUploadData(base64) {
        this.base64 = base64
        this.updateImageSize(base64)
      },
      updateImageSize(src) {
        var image = new Image()
        image.src = src
        const setSize = this.setSize.bind(this)
        image.addEventListener('load', () => setSize(image))
      },
      onImageLoad() {
        this.updateImageSize(this.imageUrl)
      },
      setSize(image) {
        const { width, height } = image
        this.size = `${width} x ${height}`
				this.actions.handleSetArtistData('mainImageWidth', width)
				this.actions.handleSetArtistData('mainImageHeight', height)
      },
		handleClickSave() {
			this.actions.handleSaveArtist({
				id: this.id,
				form: this.form,
			})
		},
	}
	}
</script>

<style>
	.bread-crumb {
		margin-left: -25px;
		margin-right: -24px;
		margin-top: -25px;
		padding-left: 26px;
		background: #d5e7f5;
	}  
	.preview {
    max-width: 80%;
    max-height: 95%;
  }
  .previev-container {
    height: 400px;
  }
  .container {
    border: 1px solid silver;
    border-radius: 8px;
  }
  .image-size {
    font-size: 12px;
    font-weight: bold;
  }
</style>